import PhotoSwipe from "photoswipe";
import PhotoSwipeLightbox from "photoswipe/lightbox";
// @ts-ignore
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';

const photoswipeStore = {
  create(dataSource: any) {
    const sm = window.innerWidth < 768;

    const left = `<svg viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='m9.121 1.06-7 7 7 7-1.06 1.061L0 8.061 8.06 0z' fill='#fff'/><path d='M15.81 7.31v1.5H1.31v-1.5z' fill='#fff'/></svg>`;

    const right = `<svg viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M14.5 7.31v1.5H0v-1.5z' fill='#fff'/><path d='m15.81 8.06-8.06 8.061-1.06-1.06 7-7-7-7L7.75 0z' fill='#fff'/></svg>`;

    const close = `<svg viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M14.121 1.06 1.061 14.122 0 13.061 13.06 0z' fill='#fff'/><path d='m14.121 13.06-1.06 1.061L0 1.061 1.06 0z' fill='#fff'/></svg>`;
    const lightbox = new PhotoSwipeLightbox({
      dataSource: dataSource,
      pswpModule: PhotoSwipe,
      zoom: false,
      counter: false,
      wheelToZoom: true,
      padding: { top: 12, bottom: sm ? 46 : 12, left: 12, right: 12 },
      bgOpacity: 1,
      arrowPrevSVG: left,
      arrowNextSVG: right,
      closeSVG: close,
    });

    // Bullets
    lightbox.on('uiRegister', () => {
      lightbox?.pswp?.ui?.registerElement({
        name: 'bulletsIndicator',
        className: 'pswp__bullets-indicator',
        appendTo: 'wrapper',
        onInit: (el: HTMLElement, pswp: PhotoSwipe) => {
          const bullets: HTMLElement[] = [];
          let bullet;
          let prevIndex = -1;

          for (let i = 0; i < pswp.getNumItems(); i++) {
            bullet = document.createElement('div');
            bullet.className = 'pswp__bullet';
            bullet.onclick = (e) => {
              pswp.goTo(bullets.indexOf(e.target as HTMLElement));
            };
            el.appendChild(bullet);
            bullets.push(bullet);
          }

          pswp.on('change', (a: any) => {
            if (prevIndex >= 0) {
              bullets[prevIndex].classList.remove('pswp__bullet--active');
            }
            bullets[pswp.currIndex].classList.add('pswp__bullet--active');
            prevIndex = pswp.currIndex;
          });
        }
      });
    });

    new PhotoSwipeDynamicCaption(lightbox, {
      type: 'below',
      captionContent: (item: any) => {
        return item.data.caption;
      },
    });

    lightbox.init();

    return lightbox;
  },
};

export default photoswipeStore;
